import type Store from '@ember-data/store'
import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { hash } from 'rsvp'
import type SchoolClass from 'teacher-ui-client/models/school-class'
import type Teacher from 'teacher-ui-client/models/teacher'
import type SessionService from 'teacher-ui-client/services/session'

export default class ManageTeachersRoute extends Route {
  @service session!: SessionService

  @service store!: Store

  queryParams = {
    sortCol: {
      replace: true,
    },
    sortDir: {
      replace: true,
    },
    sortCompare: {
      replace: true,
    },
    currentPage: {
      replace: true,
    },
    textFilter: {
      replace: true,
    },
    selectedIds: {
      replace: true,
    },
    recordsPerPage: {
      replace: true,
    },
  }

  buildRouteInfoMetadata() {
    return {
      rolloverLock: {
        subco: {
          lockOtherSubscriptionType: true,
        },
      },
    }
  }

  async model() {
    const teachers = await this.store.query<Teacher>('teacher', {
      // @ts-expect-error - include types not correct
      include: [
        'school-classes',
        'school-classes.students', // we need students for student counts // counts should come from BE
        'teacher-subscriptions',
      ].join(','),
    })
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const schoolClasses = this.store.peekAll<SchoolClass>('school-class')
    const { currentTeacher, currentSchool } = this.session

    return hash({
      currentTeacher,
      teachers,
      subscriptionType,
      school: currentSchool,
      schoolClasses,
    })
  }
}
